export { default as fetchCompleteCollection } from './fetchCompleteCollection';
